(ns common.schema.entities.role
  (:require [common.schema.schema-utils :as su]))

(def roles {:role/none            {:translations {:en "None"}}
            :role/guest-survey    {:translations {:en "Survey guest"}}
            :role/guest-lp-portal {:transactions {:en "LP Portal guest"}}
            :role/guest-sell-side {:translations {:en "Sell-side guest"}}
            :role/guest-buy-side  {:translations {:en "Buy-side guest"}}
            :role/user            {:translations {:en "User"}}
            :role/admin           {:translations {:en "Admin"}}
            :role/account-owner   {:translations {:en "Owner"}}
            :role/zadmin          {:translations {:en "Zadmin"}}
            :role/sys-admin       {:translations {:en "Sys-admin"}}
            :role/system          {:translations {:en "System"}}})

(def role-schema
  (vec (concat (su/keyword-multi-field :role/modules
                                       "Modules"
                                       nil
                                       {:authorization    su/access-system-system
                                        :system-semantics su/system-controlled-optional-field-semantics})
               (su/keyword-field :role/role "Role" nil {:authorization    su/access-system-ssg
                                                        :system-semantics su/system-controlled-required-field-semantics
                                                        :system-required? true})
               (su/single-ref-field :role/subject "Subject (account)" [:entity.type/account] {:authorization    su/access-system-ssg
                                                                                              :system-semantics su/system-controlled-required-field-semantics
                                                                                              :system-required? true})
               (su/single-ref-field :role/target "Target" [:entity.type/company :entity.type/oppo :entity.type/tenant :entity.type/workspace]
                                    {:authorization    su/access-system-ssg
                                     :system-semantics su/system-controlled-required-field-semantics
                                     :system-required? true})
               (su/text-edn-field :role/encryption-credentials
                                  "Encryption credentials"
                                  {:authorization    su/access-system-system
                                   :system-semantics su/system-controlled-optional-field-semantics}))))
